/* Margo theme scripts. */
(() => {
  const KEY = 'margo.lang.chosen';
  const store = {
    get: () => {
      try {
        return localStorage.getItem(KEY);
      } catch {
        return null;
      }
    },
    set: (v) => {
      try {
        localStorage.setItem(KEY, v);
      } catch {
        /* storage blocked: the choice still applies to this page */
      }
    },
  };

  // The language picker reloads the page in the chosen language (Shopify localization form),
  // and the choice is remembered so the automatic language below never overrides it.
  document.addEventListener('change', (e) => {
    const select = e.target.closest && e.target.closest('select[data-autosubmit]');
    if (!select || !select.form) return;
    store.set(select.value);
    select.form.submit();
  });

  // First visit: show the page in the visitor's browser language when the shop publishes it.
  const shop = window.MARGO_SHOP;
  const locales = (shop && shop.locales) || [];
  if (locales.length > 1 && !store.get()) {
    const current = locales.find((l) => l.current);
    const wanted = (navigator.languages || [navigator.language || ''])
      .map((t) => String(t).slice(0, 2).toLowerCase())
      .find((code) => locales.some((l) => l.code.slice(0, 2) === code));
    const target = wanted && locales.find((l) => l.code.slice(0, 2) === wanted);
    store.set(target ? target.code : current ? current.code : 'auto');
    if (target && current && target.code !== current.code) {
      const trim = (r) => (r === '/' ? '' : r.replace(/\/$/, ''));
      const rest = location.pathname.slice(trim(current.root).length) || '/';
      location.replace(trim(target.root) + rest + location.search + location.hash);
    }
  }

  // In-page links to folded sections (privacy, legal notice) open them.
  const openTarget = () => {
    const el = location.hash && document.getElementById(location.hash.slice(1));
    if (el && el.tagName === 'DETAILS') el.open = true;
  };
  document.addEventListener('click', (e) => {
    const a = e.target.closest && e.target.closest('a[data-open-details]');
    if (a) setTimeout(openTarget, 0);
  });
  window.addEventListener('hashchange', openTarget);
  openTarget();
})();
